export const APPS_STATUS_ERROR = Symbol('APPS_STATUS_ERROR')
export const APPS_STATUS_READY = Symbol('APPS_STATUS_READY')
export const APPS_STATUS_LOADING = Symbol('APPS_STATUS_LOADING')
export const APPS_STATUS_UNLOADED = Symbol('APPS_STATUS_UNLOADED')

export const DAO_STATUS_ERROR = Symbol('DAO_STATUS_ERROR')
export const DAO_STATUS_READY = Symbol('DAO_STATUS_READY')
export const DAO_STATUS_LOADING = Symbol('DAO_STATUS_LOADING')
export const DAO_STATUS_UNLOADED = Symbol('DAO_STATUS_UNLOADED')

export const ACTIVITY_STATUS_CONFIRMED = Symbol('ACTIVITY_STATUS_CONFIRMED')
export const ACTIVITY_STATUS_FAILED = Symbol('ACTIVITY_STATUS_FAILED')
export const ACTIVITY_STATUS_PENDING = Symbol('ACTIVITY_STATUS_PENDING')
export const ACTIVITY_STATUS_TIMED_OUT = Symbol('ACTIVITY_STATUS_TIMED_OUT')

export const ACTIVITY_TYPE_TRANSACTION = Symbol('ACTIVITY_TYPE_TRANSACTION')

export const TRANSACTION_STATUS_ERROR = Symbol('TRANSACTION_STATUS_ERROR')
export const TRANSACTION_STATUS_PENDING = Symbol('TRANSACTION_STATUS_PENDING')
export const TRANSACTION_STATUS_SUCCESS = Symbol('TRANSACTION_STATUS_SUCCESS')
export const TRANSACTION_STATUS_UPCOMING = Symbol('TRANSACTION_STATUS_UPCOMING')
